import { AdminLayout } from '@/components/Layout';
import React, { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth';
import { usePagination } from '@/hooks/usePagination';
import { SubscriptionType } from '@/features/user/SubscriptionType/SubscriptionType';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import AllRequestsList from './AllRequestsList';

const AllRequests = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const { page, changePage } = usePagination();
  const { user, refetchUser } = useAuth();

  useEffect(() => {
    setLoading(true);
    refetchUser();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [user?.has_subscription]);
  return (
    <AdminLayout title="All Requests">
      {loading && <TableLoader />}
      {!loading ? (
        user?.has_subscription === true ? (
          <AllRequestsList page={page} changePage={changePage} />
        ) : (
          <SubscriptionType />
        )
      ) : null}
    </AdminLayout>
  );
};

export default AllRequests;
